// src/admin/AdminRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

// Super admin emails - these users have access to everything
const SUPER_ADMIN_EMAILS = [
  'matthew@backpass.co',
  'mgriff7@gmail.com',
  'mhgbackpass@gmail.com',
  'mhgcommercial@gmail.com'
];

function AdminRoute({ children }) {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      if (!currentUser) {
        setHasAccess(false);
        setLoading(false);
        return;
      }

      try {
        // Force token refresh to ensure latest claims
        await currentUser.getIdToken(true);

        // Check if super admin
        if (SUPER_ADMIN_EMAILS.includes(currentUser.email?.toLowerCase())) {
          setHasAccess(true);
          setLoading(false);
          return;
        }

        // Check user permissions from Firestore
        console.log('Checking permissions for user:', currentUser.email, currentUser.uid);
        const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const permissions = userData.adminPermissions || {};
          console.log('User data found:', userData);
          console.log('isAdmin:', userData.isAdmin);
          console.log('adminPermissions:', permissions);

          // Check if user has any admin access at all
          const hasAdminAccess = userData.isAdmin === true || Object.values(permissions).some(v => v);
          console.log('Has admin access:', hasAdminAccess);
          setHasAccess(hasAdminAccess);
        } else {
          console.log('User document not found for UID:', currentUser.uid);
          console.log('Attempting to check by email as fallback...');
          // Sometimes the document might be keyed by email instead of UID
          setHasAccess(false);
        }
      } catch (error) {
        console.error('Error checking admin access:', error);
        console.error('Error details:', error.code, error.message);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [currentUser]);

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Checking permissions...</div>;
  }

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default AdminRoute;